import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { INotificationState, notificationFacadeBase } from './notification.state';
import { Notification } from './notification.model';
import { NotificationService } from './notification.service';
import { Observable, ReplaySubject, from } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { StatutNotificationEnum } from './statut.enum';



@Injectable()
export class NotificationFacade extends notificationFacadeBase {

    private _notifications: ReplaySubject<Notification[]> = new ReplaySubject<Notification[]>(1);



    constructor(_store: Store<INotificationState>, private _notificationService: NotificationService) {
        super(Notification, _store);
    }

    get notifications$(): Observable<Notification[]> {
        return this._notifications.asObservable();
    }

    store(notifications: Notification[]): Observable<Notification[]> {
        // Load the notifications
        this._notifications.next(notifications);

        // Return the notifications
        return this.notifications$;
    }

    markAllAsRead(notifications: Notification[]): string {

        if (notifications) {
            for (let not of notifications) {
                not.statut = StatutNotificationEnum.Viewed;
                return this.update(not);

            }
        }


    }

}
